module.exports = "/_next/static/images/48b9bda931b94a8772766beb2b14d3fb-steps-mobile.jpg.webp";